/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Notifications_Toast_DeletedInputs */

const he_account_notifications_toast_deleted = /** @type {(inputs: Account_Notifications_Toast_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ההתראה נמחקה`)
};

const en_account_notifications_toast_deleted = /** @type {(inputs: Account_Notifications_Toast_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notification deleted`)
};

/**
* | output |
* | --- |
* | "Notification deleted" |
*
* @param {Account_Notifications_Toast_DeletedInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const account_notifications_toast_deleted = /** @type {((inputs?: Account_Notifications_Toast_DeletedInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Notifications_Toast_DeletedInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_account_notifications_toast_deleted(inputs)
	return en_account_notifications_toast_deleted(inputs)
});